<div class="share-delete">
    <sync-dialog
      [config]="{
        title: 'Remove sharing',
        actionButton: 'Remove', 
        cancelButton: 'Cancel',
        subTitle: name,
        isClosable: false,
        onCancelClick: closeDialog,
        onActionClick: stopShare,
        isButtonLoading: spinner,
      }"
       [isCritical]="true"
      [open]="showDialog"
      [isFullScreen]="isSmallScreen"
    >
    <div class="share-delete-wrapper">
          <p class="body-1 text-wrapper">Everyone will be removed from this folder. You will still keep a copy of this folder in Sync.</p>
          <sync-divider [text]="'Content'" [size]="'default'"></sync-divider>
          <p class="body-bold-1 text-wrapper">Would you like other users to keep a copy of this folder?</p>
        <div class="check-box">
          <sync-radio-button-group class="radio-buttons" [radioButtonItems]="options" [changeRadioButtonValue]="selectedChange" />
        </div>
    </div>
    </sync-dialog>
  </div>
  